import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TrainingItemPersistenceService } from '../services/training-item-persistence.service';
import { TrainingItemConstants } from '../constants/training-item-constants';

@Component({
  selector: 'app-training-item-group-slider',
  templateUrl: './training-item-group-slider.component.html',
  styleUrls: ['./training-item-group-slider.component.scss']
})
export class TrainingItemGroupSliderComponent implements OnInit {
  @Output() isTrainingItemSliderActive = new EventEmitter<boolean>();
  @Input() isTrainingItemSliderOpen: boolean = false;
  trainingItemGroupSliderTitle: String = TrainingItemConstants.Training_Item_Slider_Title;

  constructor(private trainingItemPersistenceService: TrainingItemPersistenceService) {

  }
  ngOnInit(): void {
    this.trainingItemGroupSliderTitle = this.trainingItemPersistenceService.isEditTrainingItemGroupSlider ? 
    TrainingItemConstants.Training_Item_Slider_Title_For_Edit : TrainingItemConstants.Training_Item_Slider_Title;
    this.trainingItemPersistenceService.closeAndResetTrainingItemSlider$.subscribe((isClose) => {
      if (isClose) { this.closeAndResetCourseSlider(); }
    });
  }

  closeSlider() {
    this.trainingItemPersistenceService.openConfirmationDialog();
  }

  closeAndResetCourseSlider() {
    this.isTrainingItemSliderOpen = false;
    this.isTrainingItemSliderActive.emit(this.isTrainingItemSliderOpen);
  }

}
